var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.hotel)?_c('acttiv'):(_vm.id)?_c('dviewcontent'):(_vm.show)?_c('dviewcontent-show'):(_vm.dview || _vm.cmDviewcontentEvents)?_c('dview'):(_vm.cmDviewcontent)?_c('cm-dviewcontent'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }